export const translations = {
  it: {
    nav: {
      rooms: "Camere",
      experience: "Il Soggiorno",
      location: "Esplora Duino",
      gallery: "Galleria",
      contacts: "Contatti",
      bookNow: "Prenota",
    },
    hero: {
      overline: "Duino · Trieste · Adriatico",
      headline: "Stay simple.\nSleep better.",
      subheadline: "Dove l'Adriatico incontra il silenzio.",
      manifesto: "The calm side of the Adriatic.",
      cta: "Pianifica il soggiorno",
      cta2: "Trova la tua camera",
      scroll: "Scopri di più",
    },
    intro: {
      text1: "Svegliati con l'Adriatico accanto a te e Trieste a pochi minuti.",
      text2: "Un posto piccolo, curato, difficile da dimenticare.",
    },
    rooms: {
      overline: "Le nostre camere",
      headline: "Camere pensate per te",
      subtext: "Ogni camera è pensata per farti sentire tranquillo, leggero e senza pensieri.",
      cta: "Vedi la camera",
      explore: "Esplora la camera",
      items: [
        {
          name: "Comfort",
          tagline: "Equilibrio perfetto tra comfort e design minimale. Luce naturale e spazio per respirare.",
        },
        {
          name: "Superior",
          tagline: "La più spaziosa. 14 m² con materasso Simmons, aria condizionata e silenzio assoluto.",
        },
        {
          name: "Economy",
          tagline: "Essenziale, curata e funzionale. Tutto ciò che ti serve, senza nulla di superfluo.",
        },
      ],
    },
    hotel_details: {
      overline: "Il nostro standard",
      headline: "Il meglio dell'ospitalità della riviera triestina",
      qualities: [
        "Materassi selezionati per il massimo comfort e riposo",
        "Linea cortesia di qualità in ogni camera",
        "Colazione con prodotti eccellenti, fatti in casa ogni mattina",
        "Una terrazza nel bosco dove rilassarsi sorseggiando un buon caffè",
      ],
      notes_title: "Note importanti",
      notes: [
        "Gli animali domestici degli ospiti non sono ammessi",
        "Le nostre camere accolgono massimo 2 ospiti. Non disponiamo di letti aggiuntivi o culle.",
      ],
    },
    experience: {
      overline: "Esperienza",
      headline: "Where design meets simplicity",
      hero_title: "Stile essenziale, effetto straordinario",
      subheadline: "Tutto ciò che ti serve. Niente di più.",
      items: [
        {
          tag: "Sleep well",
          title: "Dormi bene",
          text: "Camere climatizzate, materassi di alta qualità per un riposo profondo e senza interruzioni.",
        },
        {
          tag: "Stay connected",
          title: "Resta connesso",
          text: "Wi-Fi veloce, Smart TV con Netflix e canali Sky, esperienza senza interruzioni.",
        },
        {
          tag: "Move easily",
          title: "Muoviti con facilità",
          text: "Parcheggio privato gratuito, e-bike e accesso alla nostra spiaggia convenzionata. Il mare è già pronto per te.",
        },
        {
          tag: "Colazione",
          title: "Una colazione da ricordare",
          text: "Prodotti fatti in casa ogni mattina, focacce fresche, pane con lievito madre e soffici torte preparate dal nostro chef e tanti altri buoni prodotti salati. Il sapore di chi mette cura in ogni dettaglio.",
        },
      ],
    },
    breakfast: {
      overline: "La colazione di Aurora",
      headline: "Un buffet che parla di noi",
      quote: "Ogni mattina un buffet ricco di prodotti fatti in casa: torte della tradizione, croissant profumati, frittata del giorno, frutta fresca di stagione. Sapori genuini come solo un contesto familiare può regalarti. Non è un semplice breakfast — è un'esperienza che inizia la giornata nel modo giusto.",
      tag1: "Tutto fatto in casa",
      tag2: "Sapori autentici",
      tag3: "Buffet ricco ogni mattina",
      cta: "Prenota e inizia la tua mattina con noi",
    },
    location: {
      overline: "Posizione",
      headline: "Posizione perfetta",
      text: "Dormire a Duino significa svegliarsi a 100 metri dal Sentiero Rilke e a 150 metri dal Castello. Vicino alla Baia di Sistiana, a pochi minuti da Trieste. Un soggiorno sul mare che non trovi ovunque.",
      cta: "Apri in Google Maps",
      tag1: "100 m dal Sentiero Rilke",
      tag2: "150 m dal Castello di Duino",
      tag3: "A pochi min dal mare e Trieste",
      page_headline: "Dove l'Adriatico rallenta.",
      page_subtitle: "Mare, scogliere, sentieri nascosti e mattine silenziose vicino a Trieste.",
      coast_headline: "La costa di Duino",
      coast_text: "Scogliere selvagge, acqua calma e mare aperto.\nUn lato diverso dell'Adriatico.",
      outdoor_headline: "Esplora il territorio",
      outdoor_text: "Dal Sentiero Rilke alle piste MTB del Carso, dalla vela al gravel. Con la nostra spiaggia convenzionata, il mare è già pronto ad accoglierti. Tutto inizia qui.",
      outdoor_activities: ["Sentiero Rilke", "MTB & Gravel", "Spiaggia convenzionata", "Vela", "Trieste — 20 min"],
      book_cta: "Prenota il tuo soggiorno",
    },
    gallery: {
      overline: "Atmosfera",
      headline: "Entra nell'atmosfera",
      subtext: "La luce, il silenzio, l'atmosfera — esattamente come sono.",
      hero_subtitle: "La luce, il silenzio, l'atmosfera — esattamente come sono.",
      opening_quote: "Certi posti non si spiegano. Si vivono.",
      cta: "Entra nell'atmosfera",
      final_line: "Vivila di persona.",
      final_cta: "Pianifica il soggiorno",
      microcopy: [
        "Mattine silenziose sul mare.",
        "Una luce che cambia tutto il giorno.",
        "Spazi progettati per respirare.",
        "The calm side of the Adriatic.",
      ],
      chapters: { stay: "Stay", coast: "Coast", mornings: "Slow mornings", explore: "Explore" },
    },
    trust: {
      overline: "I nostri ospiti",
      headline: "Scelto per la semplicità. Ricordato per tutto il resto.",
      text: "Chi sceglie di dormire a Duino, a due passi dal Castello di Duino e dalla Baia di Sistiana, trova all'Hotel Aurora il comfort che cercava — e molto di più.",
      phrases: [
        "Dormire vicino alla Baia di Sistiana come si deve",
        "Un soggiorno a due passi dal Castello di Duino",
        "Dormire sul mare, svegliarsi in un posto speciale",
      ],
    },
    trust_strip: {
      stars: "★★★★★",
      text: "Amato per l'atmosfera tranquilla e la vista sul mare",
      benefits: ["Parcheggio gratuito", "Spiaggia convenzionata", "Sentiero Rilke", "Hotel piccolo"],
      scarcity: "Camere limitate · Prenota direttamente",
    },
    contact: {
      cta_overline: "La tua fuga sul mare",
      cta_headline: "Pianifica il tuo soggiorno",
      cta_text: "Prenota direttamente per il miglior prezzo garantito. Senza intermediari.",
      cta_button: "Pianifica il soggiorno",
      contact_overline: "Contatti",
      contact_headline: "Siamo qui per te",
      phone_label: "Telefono",
      whatsapp_label: "WhatsApp",
      email_label: "Email",
      address_label: "Indirizzo",
      address: "Frazione Duino 15 · 34011 Duino Aurisina (TS)",
      whatsapp_cta: "Scrivici su WhatsApp",
    },
    footer: {
      microcopy: "The calm side of the Adriatic.",
      rights: "Tutti i diritti riservati",
    },
  },

  en: {
    nav: {
      rooms: "Rooms",
      experience: "The Stay",
      location: "Explore",
      gallery: "Gallery",
      contacts: "Contact",
      bookNow: "Book",
    },
    hero: {
      overline: "Duino · Trieste · Adriatic Sea",
      headline: "Stay simple.\nSleep better.",
      subheadline: "Where the Adriatic meets silence.",
      manifesto: "The calm side of the Adriatic.",
      cta: "Plan your stay",
      cta2: "Find your room",
      scroll: "Discover more",
    },
    intro: {
      text1: "Wake up with the Adriatic at your side and Trieste just minutes away.",
      text2: "A small, carefully curated hotel. Hard to leave.",
    },
    rooms: {
      overline: "Our rooms",
      headline: "Rooms designed around you",
      subtext: "Every room is designed to feel quiet, light and effortless.",
      cta: "See room",
      explore: "Explore room",
      items: [
        {
          name: "Comfort",
          tagline: "Perfect balance between space and simplicity. Natural light and room to breathe.",
        },
        {
          name: "Superior",
          tagline: "More space, more comfort. 14 m² with a Simmons mattress, A/C and total silence.",
        },
        {
          name: "Economy",
          tagline: "Essential, thoughtful and functional. Everything you need, nothing you don't.",
        },
      ],
    },
    hotel_details: {
      overline: "Our standards",
      headline: "The finest hospitality on the Trieste Riviera",
      qualities: [
        "Premium mattresses selected for deep, restful sleep",
        "Quality amenity line in every room",
        "Exceptional breakfast — outstanding homemade products every morning",
        "A terrace in the woods — the perfect spot to relax over a good coffee",
      ],
      notes_title: "Important notes",
      notes: [
        "Guests' pets are not admitted",
        "Our rooms accommodate a maximum of 2 guests. Extra beds and cribs are not available.",
      ],
    },
    experience: {
      overline: "Experience",
      headline: "Where design meets simplicity",
      hero_title: "Design meets simplicity",
      subheadline: "Everything you need. Nothing you don't.",
      items: [
        {
          tag: "Sleep well",
          title: "Sleep well",
          text: "Air-conditioned rooms with high-quality mattresses for deep, uninterrupted rest.",
        },
        {
          tag: "Stay connected",
          title: "Stay connected",
          text: "Fast Wi-Fi, Smart TV with Netflix and Sky channels, seamless experience.",
        },
        {
          tag: "Move easily",
          title: "Move easily",
          text: "Free private parking, e-bike rental and access to our affiliated beach. The sea is already waiting.",
        },
        {
          tag: "Breakfast",
          title: "A breakfast to remember",
          text: "Every morning: fresh focaccia, sourdough bread, homemade cakes from our chef and a generous spread of savoury delights. The taste of people who truly care.",
        },
      ],
    },
    breakfast: {
      overline: "The Aurora Breakfast",
      headline: "A buffet that speaks for itself",
      quote: "Every morning a buffet full of homemade products: traditional cakes, warm croissants, daily frittata, fresh seasonal fruit. Genuine flavors that only a family setting can offer. It's not just breakfast — it's an experience that starts your day the right way.",
      tag1: "Everything homemade",
      tag2: "Authentic flavors",
      tag3: "A rich buffet every morning",
      cta: "Book and start your morning with us",
    },
    location: {
      overline: "Location",
      headline: "Perfectly placed",
      text: "Sleeping in Duino means waking up 100 metres from the Rilke Trail and 150 metres from the Castle. Walking distance to Sistiana Bay, minutes from Trieste. A stay by the sea you won't find anywhere else.",
      cta: "Open in Google Maps",
      tag1: "100 m from the Rilke Trail",
      tag2: "150 m from Duino Castle",
      tag3: "Minutes from sea & Trieste",
      page_headline: "Where the Adriatic slows down.",
      page_subtitle: "Sea, cliffs, hidden paths and quiet mornings near Trieste.",
      coast_headline: "The coastline of Duino",
      coast_text: "Wild cliffs, calm water and open sea.\nA different side of the Adriatic.",
      outdoor_headline: "Explore the territory",
      outdoor_text: "From the Rilke Trail to MTB on the Karst, from sailing to gravel. With our affiliated beach access, the sea is already waiting for you. Everything starts here.",
      outdoor_activities: ["Rilke Trail", "MTB & Gravel", "Affiliated beach", "Sailing", "Trieste — 20 min"],
      book_cta: "Plan your stay",
    },
    gallery: {
      overline: "Atmosphere",
      headline: "See how it feels",
      subtext: "The light, the quiet, the atmosphere — exactly as it is.",
      hero_subtitle: "The light, the quiet, the atmosphere — exactly as it is.",
      opening_quote: "Some places don't need words. Just light and quiet.",
      cta: "Explore the atmosphere",
      final_line: "Now experience it in person.",
      final_cta: "Plan your stay",
      microcopy: [
        "Quiet mornings by the sea.",
        "Light that changes throughout the day.",
        "Spaces made to breathe.",
        "The calm side of the Adriatic.",
      ],
      chapters: { stay: "Stay", coast: "Coast", mornings: "Slow mornings", explore: "Explore" },
    },
    trust: {
      overline: "Our guests",
      headline: "Chosen for its simplicity. Remembered for everything else.",
      text: "Guests who choose to sleep by the sea near Duino Castle and Sistiana Bay find at Hotel Aurora the comfort they were looking for — and much more.",
      phrases: [
        "Sleep by the sea, steps from Sistiana Bay",
        "A stay next to Duino Castle like no other",
        "Where the Adriatic coast becomes your backyard",
      ],
    },
    trust_strip: {
      stars: "★★★★★",
      text: "Loved for its quiet atmosphere and sea views",
      benefits: ["Free parking", "Affiliated beach", "Near Rilke Trail", "Small hotel"],
      scarcity: "Limited rooms · Book direct",
    },
    contact: {
      cta_overline: "Escape to the sea",
      cta_headline: "Plan your stay",
      cta_text: "Book direct for the best price guaranteed. No middlemen, no extra fees.",
      cta_button: "Plan your stay",
      contact_overline: "Contact",
      contact_headline: "We are here for you",
      phone_label: "Phone",
      whatsapp_label: "WhatsApp",
      email_label: "Email",
      address_label: "Address",
      address: "Frazione Duino 15 · 34011 Duino Aurisina (TS), Italy",
      whatsapp_cta: "Chat on WhatsApp",
    },
    footer: {
      microcopy: "The calm side of the Adriatic.",
      rights: "All rights reserved",
    },
  },

  de: {
    nav: {
      rooms: "Zimmer",
      experience: "Der Aufenthalt",
      location: "Duino entdecken",
      gallery: "Galerie",
      contacts: "Kontakt",
      bookNow: "Buchen",
    },
    hero: {
      overline: "Duino · Triest · Adria",
      headline: "Stay simple.\nSleep better.",
      subheadline: "Wo die Adria auf Stille trifft.",
      manifesto: "The calm side of the Adriatic.",
      cta: "Urlaub planen",
      cta2: "Ihr Zimmer finden",
      scroll: "Mehr entdecken",
    },
    intro: {
      text1: "Aufwachen mit der Adria an Ihrer Seite und Triest nur Minuten entfernt.",
      text2: "Ein kleines, sorgfältig kuratiertes Hotel. Schwer zu verlassen.",
    },
    rooms: {
      overline: "Unsere Zimmer",
      headline: "Zimmer, die um Sie herum gestaltet sind",
      subtext: "Jedes Zimmer ist darauf ausgerichtet, Ruhe, Leichtigkeit und Sorglosigkeit zu vermitteln.",
      cta: "Zimmer ansehen",
      explore: "Zimmer erkunden",
      items: [
        {
          name: "Comfort",
          tagline: "Perfekte Balance zwischen Komfort und minimalem Design. Natürliches Licht, Raum zum Atmen.",
        },
        {
          name: "Superior",
          tagline: "Mehr Platz, mehr Komfort. 14 m² mit Simmons-Matratze, Klimaanlage und völliger Ruhe.",
        },
        {
          name: "Economy",
          tagline: "Wesentlich, durchdacht und funktional. Alles was Sie brauchen, nichts Überflüssiges.",
        },
      ],
    },
    hotel_details: {
      overline: "Unser Standard",
      headline: "Das Beste der Gastfreundschaft an der Triester Riviera",
      qualities: [
        "Erstklassige Matratzen für tiefen, erholsamen Schlaf",
        "Hochwertige Pflegelinie in jedem Zimmer",
        "Außergewöhnliches Frühstück — exzellente, täglich frisch hausgemachte Produkte",
        "Eine Terrasse im Wald — der perfekte Ort zum Entspannen bei einem guten Kaffee",
      ],
      notes_title: "Wichtige Hinweise",
      notes: [
        "Haustiere der Gäste sind nicht gestattet",
        "Unsere Zimmer bieten Platz für maximal 2 Gäste. Zusatzbetten und Babybetten sind nicht verfügbar.",
      ],
    },
    experience: {
      overline: "Erlebnis",
      headline: "Where design meets simplicity",
      hero_title: "Design, das begeistert",
      subheadline: "Alles was Sie brauchen. Nichts was Sie nicht brauchen.",
      items: [
        {
          tag: "Gut schlafen",
          title: "Gut schlafen",
          text: "Klimatisierte Zimmer mit hochwertigen Matratzen für tiefen, ungestörten Schlaf.",
        },
        {
          tag: "Verbunden bleiben",
          title: "Verbunden bleiben",
          text: "Schnelles WLAN, Smart TV mit Netflix und Sky-Kanälen, nahtloses Erlebnis.",
        },
        {
          tag: "Einfach bewegen",
          title: "Einfach bewegen",
          text: "Kostenloser Privatparkplatz, E-Bike und Zugang zu unserem exklusiven Partnerstrand. Das Meer wartet schon auf Sie.",
        },
        {
          tag: "Frühstück",
          title: "Ein Frühstück zum Erinnern",
          text: "Jeden Morgen frische Focaccia, Sauerteigbrot, hausgemachte Kuchen vom Chef und herzhafte Spezialitäten. Echter Geschmack, mit Herzblut zubereitet.",
        },
      ],
    },
    breakfast: {
      overline: "Das Aurora Frühstück",
      headline: "Ein Buffet, das für sich spricht",
      quote: "Jeden Morgen ein Buffet voller hausgemachter Produkte: traditionelle Kuchen, duftende Croissants, tagesfrische Frittata, frisches Saisonobst. Echte Aromen, die nur ein familiäres Umfeld bieten kann. Kein gewöhnliches Frühstück — ein Erlebnis, das Ihren Tag richtig beginnt.",
      tag1: "Alles hausgemacht",
      tag2: "Authentische Aromen",
      tag3: "Reiches Buffet jeden Morgen",
      cta: "Buchen und den Morgen mit uns beginnen",
    },
    location: {
      overline: "Lage",
      headline: "Perfekt gelegen",
      text: "In Duino schlafen bedeutet, 100 Meter vom Rilke-Pfad und 150 Meter vom Schloss entfernt aufzuwachen. Zu Fuß zur Bucht von Sistiana, Minuten nach Triest. Ein Aufenthalt am Meer, den man nirgendwo sonst findet.",
      cta: "In Google Maps öffnen",
      tag1: "100 m vom Rilke-Pfad",
      tag2: "150 m vom Schloss Duino",
      tag3: "Min. vom Meer & Triest",
      page_headline: "Wo die Adria langsamer wird.",
      page_subtitle: "Meer, Klippen, verborgene Pfade und stille Morgen nahe Triest.",
      coast_headline: "Die Küste von Duino",
      coast_text: "Wilde Klippen, ruhiges Wasser und offenes Meer.\nEine andere Seite der Adria.",
      outdoor_headline: "Das Territorium erkunden",
      outdoor_text: "Vom Rilke-Pfad zu MTB-Strecken im Karst, vom Segeln zum Gravel. Mit unserem exklusiven Partnerstrand ist das Meer bereits für Sie bereit. Alles beginnt hier.",
      outdoor_activities: ["Rilke-Pfad", "MTB & Gravel", "Exklusiver Strand", "Segeln", "Triest — 20 Min."],
      book_cta: "Urlaub planen",
    },
    gallery: {
      overline: "Atmosphäre",
      headline: "Spür die Atmosphäre",
      subtext: "Das Licht, die Stille, die Atmosphäre — genau so wie es ist.",
      hero_subtitle: "Das Licht, die Stille, die Atmosphäre — genau so wie es ist.",
      opening_quote: "Manche Orte erklären sich nicht. Man erlebt sie.",
      cta: "Atmosphäre entdecken",
      final_line: "Erleben Sie es persönlich.",
      final_cta: "Urlaub planen",
      microcopy: [
        "Stille Morgen am Meer.",
        "Licht, das sich den ganzen Tag verändert.",
        "Räume zum Atmen.",
        "The calm side of the Adriatic.",
      ],
      chapters: { stay: "Stay", coast: "Coast", mornings: "Slow mornings", explore: "Explore" },
    },
    trust: {
      overline: "Unsere Gäste",
      headline: "Gewählt wegen der Schlichtheit. Unvergessen wegen allem anderen.",
      text: "Wer in Duino übernachtet, unweit von Schloss Duino und der Bucht von Sistiana, findet im Hotel Aurora genau den Komfort, den er gesucht hat — und noch viel mehr.",
      phrases: [
        "Schlafen am Meer, neben der Bucht von Sistiana",
        "Übernachten direkt neben Schloss Duino",
        "Wo die Adria Ihr Vorgarten wird",
      ],
    },
    trust_strip: {
      stars: "★★★★★",
      text: "Beliebt für seine ruhige Atmosphäre und den Meerblick",
      benefits: ["Kostenloser Parkplatz", "Exklusiver Strand", "Nah am Rilke-Pfad", "Kleines Hotel"],
      scarcity: "Begrenzte Zimmer · Direkt buchen",
    },
    contact: {
      cta_overline: "Ihr Rückzug ans Meer",
      cta_headline: "Ihren Urlaub planen",
      cta_text: "Direkt buchen für den garantiert besten Preis. Ohne Vermittler, ohne Aufpreise.",
      cta_button: "Urlaub planen",
      contact_overline: "Kontakt",
      contact_headline: "Wir sind für Sie da",
      phone_label: "Telefon",
      whatsapp_label: "WhatsApp",
      email_label: "E-Mail",
      address_label: "Adresse",
      address: "Frazione Duino 15 · 34011 Duino Aurisina (TS), Italien",
      whatsapp_cta: "WhatsApp schreiben",
    },
    footer: {
      microcopy: "The calm side of the Adriatic.",
      rights: "Alle Rechte vorbehalten",
    },
  },

  nl: {
    nav: {
      rooms: "Kamers",
      experience: "Jouw Verblijf",
      location: "Ontdek Duino",
      gallery: "Galerij",
      contacts: "Contact",
      bookNow: "Boek",
    },
    hero: {
      overline: "Duino · Triëst · Adriatische Zee",
      headline: "Stay simple.\nSleep better.",
      subheadline: "Een designhotel aan zee, vlak bij Triëst. Perfect voor koppels en zakenreizen.",
      manifesto: "The calm side of the Adriatic.",
      cta: "Plan je verblijf",
      cta2: "Ontdek de kamers",
      scroll: "Ontdek meer",
    },
    intro: {
      text1: "Word wakker met de Adriatische Zee aan je zijde en Triëst op een steenworp afstand.",
      text2: "Een klein, zorgvuldig gecureerd hotel. Moeilijk om te vergeten.",
    },
    rooms: {
      overline: "Onze kamers",
      headline: "Kamers ontworpen voor jou",
      subtext: "Alles wat je nodig hebt, precies waar je het verwacht. Strakke lijnen, zacht licht. Geen overbodige luxe. Alleen comfort.",
      cta: "Bekijk kamer",
      explore: "Kamer verkennen",
      items: [
        { name: "Comfort", tagline: "Perfecte balans tussen ruimte en minimalistisch design. Natuurlijk licht en ruimte om te ademen." },
        { name: "Superior", tagline: "De ruimste kamer. 14 m² met Simmons-matras, airco en volledige stilte." },
        { name: "Economy", tagline: "Essentieel, doordacht en functioneel. Alles wat je nodig hebt, niets wat je niet nodig hebt." },
      ],
    },
    experience: {
      overline: "Jouw Verblijf",
      headline: "Where design meets simplicity",
      hero_title: "Essentiële stijl, buitengewoon resultaat",
      subheadline: "Alles wat je nodig hebt. Niets wat je niet nodig hebt.",
      items: [
        { tag: "Goed slapen", title: "Goed slapen", text: "Geklimatiseerde kamers met hoogwaardige matrassen voor een diepe, ononderbroken nachtrust." },
        { tag: "Altijd verbonden", title: "Altijd verbonden", text: "Snel wifi, Smart TV met Netflix en Sky-kanalen, naadloze ervaring." },
        { tag: "Makkelijk mobiel", title: "Makkelijk mobiel", text: "Gratis privéparkeerplaats, e-bike en toegang tot ons aangesloten strand. De zee wacht al op je." },
        { tag: "Ontbijt", title: "Een ontbijt om nooit te vergeten", text: "Elke ochtend verse focaccia, zuurdesembrood, huisgemaakte taarten van onze chef en een royale selectie hartige lekkernijen. De smaak van wie echt om elk detail geeft." },
      ],
    },
    hotel_details: {
      overline: "Onze standaard",
      headline: "Het beste van de gastvrijheid aan de Triestse Riviera",
      qualities: [
        "Premium matrassen voor een diepe, verkwikkende nachtrust",
        "Kwaliteitsvolle verzorgingslijn in elke kamer",
        "Uitzonderlijk ontbijt — uitstekende, dagelijks verse huisgemaakte producten",
        "Een terras in het bos — de perfecte plek om te ontspannen met een goede koffie",
      ],
      notes_title: "Belangrijke informatie",
      notes: [
        "Huisdieren van gasten zijn niet toegestaan",
        "Onze kamers zijn geschikt voor maximaal 2 gasten. Extra bedden en wiegjes zijn niet beschikbaar.",
      ],
    },
    breakfast: {
      overline: "Het Aurora Ontbijt",
      headline: "Een buffet dat voor zichzelf spreekt",
      quote: "Elke ochtend een buffet vol huisgemaakte producten: traditionele taarten, geurige croissants, daagse frittata, vers seizoensfruit. Authentieke smaken die alleen een familieomgeving kan bieden. Geen gewoon ontbijt — een ervaring die je dag op de beste manier begint.",
      tag1: "Alles huisgemaakt",
      tag2: "Authentieke smaken",
      tag3: "Rijke buffet elke ochtend",
      cta: "Boek en begin je ochtend met ons",
    },
    location: {
      overline: "Locatie",
      headline: "Perfect gelegen",
      text: "Slapen in Duino betekent wakker worden op 100 meter van het Rilke-pad en op 150 meter van het kasteel. Loopafstand van de Baai van Sistiana, minuten van Triëst. Een verblijf aan zee dat je nergens anders vindt.",
      cta: "Openen in Google Maps",
      tag1: "100 m van het Rilke-pad",
      tag2: "150 m van Kasteel Duino",
      tag3: "Minuten van zee & Triëst",
      page_headline: "Waar de Adriatische Zee rustiger wordt.",
      page_subtitle: "Zee, kliffen, verborgen paden en stille ochtenden vlak bij Triëst.",
      coast_headline: "De kust van Duino",
      coast_text: "Wilde kliffen, kalm water en open zee.\nEen andere kant van de Adriatische Zee.",
      outdoor_headline: "Verken het gebied",
      outdoor_text: "Van het Rilke-pad tot MTB-routes op de Karst, van zeilen tot gravel. Met ons aangesloten strand is de zee al voor je klaar. Alles begint hier.",
      outdoor_activities: ["Rilke-pad", "MTB & Gravel", "Aangesloten strand", "Zeilen", "Triëst — 20 min"],
      book_cta: "Plan je verblijf",
    },
    gallery: {
      overline: "Sfeer",
      headline: "Voel de sfeer",
      subtext: "Licht, stilte, atmosfeer — precies zoals het is.",
      hero_subtitle: "Ontworpen voor reizigers die eenvoud, stilte en slim comfort waarderen.",
      opening_quote: "Sommige plekken hoeven niet uitgelegd te worden. Die beleef je.",
      cta: "Ontdek de sfeer",
      final_line: "Beleef het zelf.",
      final_cta: "Plan je verblijf",
      microcopy: [
        "Stille ochtenden aan zee.",
        "Licht dat de hele dag verandert.",
        "Ruimtes ontworpen om te ademen.",
        "The calm side of the Adriatic.",
      ],
      chapters: { stay: "Stay", coast: "Coast", mornings: "Slow mornings", explore: "Explore" },
    },
    trust: {
      overline: "Onze gasten",
      headline: "Gekozen om zijn eenvoud. Herinnerd om al het andere.",
      text: "Wie kiest te slapen in Duino, vlak bij Kasteel Duino en de Baai van Sistiana, vindt bij Hotel Aurora het comfort waarnaar ze zochten — en veel meer.",
      phrases: [
        "Slapen aan de Baai van Sistiana zoals het hoort",
        "Een verblijf vlak naast Kasteel Duino",
        "Wakker worden aan zee, op een bijzondere plek",
      ],
    },
    trust_strip: {
      stars: "★★★★★",
      text: "Geliefd om zijn rustige sfeer en zeezicht",
      benefits: ["Gratis parkeren", "Aangesloten strand", "Rilke-pad", "Klein hotel"],
      scarcity: "Beperkt aantal kamers · Direct boeken",
    },
    contact: {
      cta_overline: "Jouw ontsnapping aan zee",
      cta_headline: "Jouw verblijf begint hier",
      cta_text: "Direct boeken voor de beste prijs gegarandeerd. Geen tussenpersonen, geen extra kosten.",
      cta_button: "Plan je verblijf",
      contact_overline: "Contact",
      contact_headline: "Wij zijn er voor jou",
      phone_label: "Telefoon",
      whatsapp_label: "WhatsApp",
      email_label: "E-mail",
      address_label: "Adres",
      address: "Frazione Duino 15 · 34011 Duino Aurisina (TS), Italië",
      whatsapp_cta: "Stuur ons een WhatsApp",
    },
    footer: {
      microcopy: "The calm side of the Adriatic.",
      rights: "Alle rechten voorbehouden",
    },
  },
};

export const BOOKING_URL = {
  it: "https://www.simplebooking.it/ibe2/hotel/5221/?hid=5221&lang=IT&cur=EUR",
  en: "https://www.simplebooking.it/ibe2/hotel/5221/?hid=5221&lang=EN&cur=EUR",
  de: "https://www.simplebooking.it/ibe2/hotel/5221/?hid=5221&lang=DE&cur=EUR",
  nl: "https://www.simplebooking.it/ibe2/hotel/5221/?hid=5221&lang=EN&cur=EUR",
};

export const CONTACT = {
  phone: "+39 040 208 212",
  phoneHref: "tel:+39040208212",
  whatsapp: "+39 349 333 7839",
  whatsappHref: "https://wa.me/393493337839",
  email: "info@auroraduino.com",
  emailHref: "mailto:info@auroraduino.com",
};

export const IMAGES = {
  // ─── Tutte le foto su customer-assets (funzionano in produzione)
  hero:            "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/4mck13lx_25394916_10211026970011720_1281683650920320737_o.jpg",
  experience_hero: "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/twf5hprg_sup.jpg",
  location_hero:   "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/xxejgu9j_96bb19d8-cf6c-4c39-b4f2-6c666514519c.jpg",
  castle:          "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/0930qpn2_Castello-di-Duino_Veduta-aerea-Est-min-2.jpg",
  gallery_hero:    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/s3j2v71e_WhatsApp%20Image%202026-05-06%20at%2022.19.16.jpeg",
  rooms_hero:      "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/n8f9r0u2_WhatsApp%20Image%202025-04-07%20at%2021.46.05%20%281%29.jpeg",
  contact_hero:    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/nb4lfwwx_WhatsApp%20Image%202026-05-06%20at%2022.19.17.jpeg",
  // ─── Camere — foto autentiche (customer-assets)
  roomEconomy:  "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/5ia9h1s3_WhatsApp%20Image%202022-05-24%20at%2007.47.04.jpeg",
  roomComfort:  "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/m8n205vo_h%20duino009.jpeg",
  roomSuperior: "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/gvj6fdx3_WhatsApp%20Image%202025-04-07%20at%2021.46.05%20%281%29.jpeg",
  // ─── Dettagli interni
  sleep: "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/x1extdct_WhatsApp%20Image%202025-04-07%20at%2021.46.06%20%281%29.jpeg",
  sea:   "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/jpw3y9cq_baia%20sistiana.jpg",
  outdoor: [
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/h6wi26yv_delfino-verde-gt.jpg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/60owo2o9_torri-slivia-explorerfvg-11.webp",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/w269h82q_milani_c1-162-2735.jpg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/0930qpn2_Castello-di-Duino_Veduta-aerea-Est-min-2.jpg",
  ],
  breakfast: [
    // Batch 2 — foto nuove buffet Aurora Duino
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/t11srkrc_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%283%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/7lewrmfp_WhatsApp%20Image%202026-05-02%20at%2021.00.11.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/uy0k1owy_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%284%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/ce0kf81f_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%288%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/yciigwry_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%289%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/tqwht5yx_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%285%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/nanp5g1i_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/kevri4u1_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%287%29.jpeg",
  ],
  gallery: [
    // Esterno hotel — veduta aerea, identity forte
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/ulgz9rqr_image.png",
    // Ingresso & reception — character dell'hotel
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/jy9ohttu_WhatsApp%20Image%202025-04-07%20at%2021.48.06%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/t1ewsdb6_WhatsApp%20Image%202025-04-07%20at%2021.48.06%20%282%29.jpeg",
    // Design camere — identità e stile
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/ddyuzm0i_WhatsApp%20Image%202022-05-24%20at%2007.47.04.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/gvj6fdx3_WhatsApp%20Image%202025-04-07%20at%2021.46.05%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/44f4514z_WhatsApp%20Image%202022-05-24%20at%2007.47.04%20%283%29.jpeg",
    // Smart comfort — dettagli e tecnologia
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/z47bnl7n_WhatsApp%20Image%202025-04-07%20at%2021.46.05%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/xgf1eku6_WhatsApp%20Image%202025-04-07%20at%2021.46.06%20%282%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/x1extdct_WhatsApp%20Image%202025-04-07%20at%2021.46.06%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/3vwe06io_WhatsApp%20Image%202025-04-07%20at%2021.46.05%20%282%29.jpeg",
    // Colazione & circondario
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/t11srkrc_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%283%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/7lewrmfp_WhatsApp%20Image%202026-05-02%20at%2021.00.11.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/ce0kf81f_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%288%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/tqwht5yx_WhatsApp%20Image%202026-05-02%20at%2021.00.11%20%285%29.jpeg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/w269h82q_milani_c1-162-2735.jpg",
    "https://customer-assets.emergentagent.com/job_aurora-duino-minimal/artifacts/h6wi26yv_delfino-verde-gt.jpg",
  ],
};
